import React, { useState } from 'react';
import { Paper, Tabs, Tab, Box } from '@mui/material';
import { PageContainer } from 'components/shared';
import General from './general';
import PaymentOptions from './paymentoptions';
import Products from './products';
import PrioritySetup from './prioritysetup';
import Orders from './ordersettings';
import Vendors from './vendorsetup';
import Customers from './customersettings';
import DeliveryMen from './deliverymansettings';
import ShippingMethod from './shippingmethod';
import DeliveryRestriction from './deliveryrestriction';
import Invoice from './invoicesettings';
import AgentSettings from './agentsettings';

const BusinessSetup = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <PageContainer
      title="Business Settings"
      subtitle="Configure your store's business, payment, delivery and vendor preferences"
    >
      <Paper
        variant="outlined"
        sx={{ borderColor: 'divider', bgcolor: 'background.paper', mb: 2 }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Business Setup Tabs"
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            '& .MuiTab-root': { minWidth: 80, fontSize: '0.75rem' },
          }}
        >
          <Tab label="General" />
          <Tab label="Payments" />
          <Tab label="Products" />
          <Tab label="Priority" />
          <Tab label="Orders" />
          <Tab label="Vendors" />
          <Tab label="Customers" />
          <Tab label="Delivery Men" />
          <Tab label="Shipping" />
          <Tab label="Restriction" />
          <Tab label="Invoice" />
          <Tab label="Agent" />
        </Tabs>
      </Paper>

      <Box sx={{ overflowY: 'auto', minHeight: '70vh' }}>
        {value === 0 && <General />}
        {value === 1 && <PaymentOptions />}
        {value === 2 && <Products />}
        {value === 3 && <PrioritySetup />}
        {value === 4 && <Orders />}
        {value === 5 && <Vendors />}
        {value === 6 && <Customers />}
        {value === 7 && <DeliveryMen />}
        {value === 8 && <ShippingMethod />}
        {value === 9 && <DeliveryRestriction />}
        {value === 10 && <Invoice />}
        {value === 11 && <AgentSettings />}
      </Box>
    </PageContainer>
  );
};

export default BusinessSetup;
